// @flow
import BaseModel from 'Stores/BaseModel';
import ListModel from 'Stores/ListModel';
import axios from 'axios';

export default class TeaserAreaModel extends BaseModel {
  id: number = 0;
  placement: string = '';
  type: string = '';

  constructor(data: Object = {}) {
    super();
    this.hydrate(data);
  }

  toJSON = () => {
    return {
      id: this.id,
      placement: this.placement,
      type: this.type,
    };
  };

  static getAll = () => {
    return axios({
      method: 'get',
      url: '/api/v1/teaserareas/',
    }).then((res: { data: Array<Object> }) => {
      return new ListModel(res.data, TeaserAreaModel);
    });
  };
}
